var map = {
	"./ar.json": [
		1194,
		95
	],
	"./en.json": [
		1195,
		96
	],
	"./widgets/ar.json": [
		887,
		8
	],
	"./widgets/en.json": [
		888,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 784;
module.exports = webpackAsyncContext;